import {useActions, useGetters, useMutators, useState} from './_default';
export default {
    namespaced: true,
    state: {
        ...useState(),
        ruler: null,
        status: false,
    },
    getters: {
        ...useGetters(),
        ruler: state => state.ruler,
        status: state => state.status,
    },
    mutations: {
        ...useMutators(),
        toggle(state) {
            state.status = !state.status;
            !state.status ? state.ruler._off() : state.ruler._on();
        },
        create(state, options) {
            if (state.ruler) return;
            state.ruler = L.control
                .ruler({
                    lengthUnit: {
                        factor: options.radio,
                        display: options.unit,
                        decimal: 2
                    }
                });
        },

        on(state) {
            if (state.status) return;
            state.status = true;
            state.ruler._on();
        },

        off(state) {
            if (!state.status) return;
            state.status = false;
            state.ruler._off();
        },

        clear(state) {
            state.ruler._toggleMeasure();
            state.ruler._pointLayer.clearLayers();
            state.ruler._polylineLayer.clearLayers();
            state.ruler._tempLine.clearLayers();

            state.ruler._tempPoint.clearLayers();
            state.ruler._toggleMeasure();
            state.status ? state.ruler._on() : state.ruler._off();
        }
    },
    actions: {
        ...useActions(),
    },
}
